import React, { useState, useEffect } from "react";
import {
  Grid,
  FormControl,
  FormLabel,
  Select,
  Button,
  Card,
  CardBody,
  Input,
  useToast,
} from "@chakra-ui/react";
import axios from "axios";
import { BASE_URL } from "../../../../Globalapi/Globalapi";

const IssueCreate = () => {
  const toast = useToast();

  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedBook, setSelectedBook] = useState("");
  const [selectedMember, setSelectedMember] = useState(""); // For selecting student/teacher
  const [dueDate, setDueDate] = useState("");
  const [categories, setCategories] = useState([]);
  const [books, setBooks] = useState([]);
  const [members, setMembers] = useState([]); // Store library members
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const schoolId = sessionStorage.getItem("school_id");

  const fetchBooks = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/admin/library/books/list_books.php?school_id=${schoolId}`
      );
      if (response.data.success) {
        setBooks(response.data.data);
      } else {
        setError(response.data.message || "Failed to fetch books");
      }
    } catch (error) {
      setError("Network Error: " + (error.message || error));
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/admin/library/category/list_category.php?school_id=${schoolId}`
      );
      if (response.data.success) {
        setCategories(response.data.data);
      } else {
        setError("Failed to fetch categories.");
      }
    } catch (error) {
      setError("Network Error: " + (error.message || error));
    }
  };

  const fetchMembers = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/admin/library/membership/list_member.php?school_id=${schoolId}`
      );
      if (response.data.success) {
        setMembers(response.data.data);
      } else {
        setError("Failed to fetch members.");
      }
    } catch (error) {
      setError("Network Error: " + (error.message || error));
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchBooks();
    fetchMembers();
  }, []);

  const handleIssueBook = async () => {
    if (!selectedBook || !selectedMember || !dueDate) {
      setError("Please fill all the required fields before submitting.");
      return;
    }

    try {
      setLoading(true);

      const jwt = sessionStorage.getItem("jwt");
      const schoolId = sessionStorage.getItem("school_id");

      const payload = {
        user_id: sessionStorage.getItem("user_id"),
        school_id: schoolId,
        member_id: selectedMember, // Member ID is required in the PHP API
        book_id: selectedBook,
        due_date: dueDate,
        is_fine: 0,
      };
      console.log("create", payload);

      const response = await axios.post(
        `${BASE_URL}/admin/library/issues/create_issue.php`, // Updated API endpoint
        payload,
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        }
      );

      if (response.data.success) {
        toast({
          title: "Book Issued Successfully",
          description: "The book has been successfully issued.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        // Optionally, reset form fields here
      } else {
        setError(response.data.message || "Error issuing book.");
      }
    } catch (error) {
      setError(
        "Network Error: " + (error.message || "An unknown error occurred")
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card w="100%" margin="auto" p={5}>
      <CardBody>
        <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={4}>
          <FormControl id="category">
            <FormLabel fontWeight="semibold">Select Category</FormLabel>
            <Select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              placeholder="Choose a Category"
            >
              {categories.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.name}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl id="book">
            <FormLabel>Select Book</FormLabel>
            <Select
              value={selectedBook}
              onChange={(e) => setSelectedBook(e.target.value)}
              placeholder="--Select a Book--"
            >
              {books.map((book) => (
                <option key={book.id} value={book.id}>
                  {book.title}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl id="member">
            <FormLabel>Select Member</FormLabel>
            <Select
              value={selectedMember}
              onChange={(e) => setSelectedMember(e.target.value)}
              placeholder="--Select a Member--"
            >
              {members.map((member) => (
                <option key={member.id} value={member.id}>
                  {member.member_name}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl id="due-date">
            <FormLabel>Due Date</FormLabel>
            <Input
              type="date"
              value={dueDate}
              onChange={(e) => setDueDate(e.target.value)}
            />
          </FormControl>
        </Grid>

        <div style={{ textAlign: "right", marginTop: "16px" }}>
          <Button
            colorScheme="blue"
            onClick={handleIssueBook}
            isLoading={loading}
          >
            Issue Book
          </Button>
        </div>

        {error && <p style={{ color: "red", marginTop: "16px" }}>{error}</p>}
      </CardBody>
    </Card>
  );
};

export default IssueCreate;
